module.exports = __webpack_public_path__ + "img/u993.3da64d29.svg";